export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14036.036bab30.jpg";